/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import classnames from "gpages/utils/classnames"
import { wxConfig, wxShare } from "@src/utils/wechat"

const Layout = ({ children, location }) => {
  const [ready, setReady] = useState(true)

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  return (
    <AppContext.Provider value={{}}>
      <Seo />
      <div className={styles.prepare}>preparing...</div>
      <div
        className={classnames(styles.main, {
          [styles.ready]: ready,
        })}
      >
        {children}
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
